module.exports = __webpack_public_path__ + "static/media/critical-discount.486895bb.png";